/**
* Use the CSS tab above to style your Element's container.
*/
import React from 'react';
import Logo from '../assets/images/logo.png';
import {CardElement} from '@stripe/react-stripe-js';
//import './Styles.css'


const CARD_ELEMENT_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};
function CardSection() {
  return (
    <>
    <div className="crd-logo">
      <span>
        <img src={Logo} alt="Tugo" />
      </span>
    </div>
    <h4 className="crd-title"><span>Card details</span></h4>
    <div className="crd-row">
      <div className="crd-flx">
        <label>
          <input type="text" placeholder="Card Holder Name" className="form-control" />
        </label>
      </div>
      <CardElement options={CARD_ELEMENT_OPTIONS} />
    </div>
    </>
  );
};
export default CardSection;